module.exports = __webpack_public_path__ + "img/gr.b41b5f52.svg";